import React, { useEffect, useState } from "react";

// --- Components --- //
import Card from "../../components/Cards/CertificationCard.jsx";

// --- CSS --- //
import "../../styles/my-certs.css"; // Import the new styles

// --- FIREBASE --- //
import { getUserCertifications } from "../../utilities/firestore/firestoreUtils.js";
import { getCurrentUserUid } from "../../utilities/auth/authUtils.js";

// --- UTILS --- //
import { formatDate, formatTime, calculateDaysUntilExpiration } from "../../utilities/timeUtils.js";

const MyCerts = () => {
  const [certifications, setCertifications] = useState([]);

  useEffect(() => {
    // Fetch certifications when the component mounts
    const fetchCertifications = async () => {
      const certs = await getUserCertifications(getCurrentUserUid());
      setCertifications(certs);
    };

    fetchCertifications();
  }, []);

  return (
    <section className="card-section">
      {certifications.length > 0 ? (
        certifications.map((cert, index) => (
          <Card
            key={index}
            certTitle={cert.title}
            certGym={cert.gym}
            certEmployee={cert.employee}
            startDate={formatDate(cert.startDate)}
            endDate={formatDate(cert.endDate)}
            startTime={formatTime(cert.startDate)}
            endTime={formatTime(cert.endDate)}
            certType={cert.type}
            dateDifference={calculateDaysUntilExpiration(cert.endDate)}
          />
        ))
      ) : (
        <div className="no-certs-container">
          <h3>No Certifications Received Yet</h3>
          <p>Check back later or complete a certification to see it here.</p>
        </div>
      )}
    </section>
  );
};

export default MyCerts;